import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=650b8dd4&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=650b8dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b8dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650b8dd4')) {
      api.createRecord('650b8dd4', component.options)
    } else {
      api.reload('650b8dd4', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=650b8dd4&scoped=true&", function () {
      api.rerender('650b8dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uNU0VI6AmA82/JS/teamMember.vue"
export default component.exports